interface FilterData {
  [key: string]: string[];
}
enum Filter {
  ALL = 'FILTER_ALL',
}

export class FilterFormComponent {
  private static filterFormComponentInstance: FilterFormComponent;
  private static filterFormSelector = '[data-js-filter-form]';
  private static filterTargetSelector = '[data-js-filter-target]';
  private static filterTargetDataSelector = '[data-js-filter-target-data]';
  private static filterTemplateSelector = '[data-js-filter-template]';
  private static filterNameSelector = 'data-filter-name';

  private filterLabelTemplate: HTMLTemplateElement;

  public static get instance(): FilterFormComponent {
    if (!FilterFormComponent.filterFormComponentInstance) {
      FilterFormComponent.filterFormComponentInstance = new FilterFormComponent();
    }

    return FilterFormComponent.filterFormComponentInstance;
  }

  private static getFilterData(filterForm: HTMLFormElement): FilterData {
    const formData = new FormData(filterForm);
    const filterData: FilterData = { };

    for (const key of formData.keys()) {
      filterData[key] = formData.getAll(key)
        .map(value => value.toString());

      if (filterData[key].includes(Filter.ALL)) {
        filterData[key] = undefined;
      }
    }

    return filterData;
  }

  private toggleFilterChange(filterElement: HTMLInputElement): void {
    const { form, name } = filterElement;
    const filterAllElement = Array.from(form.elements).find((otherFilterElement: HTMLInputElement) =>
      otherFilterElement.name === name && otherFilterElement.value === Filter.ALL
    ) as HTMLInputElement;
    const otherCheckedFilterElements = Array.from(form.elements).filter((otherFilterElement: HTMLInputElement) =>
      otherFilterElement.name === name &&
      otherFilterElement.value !== Filter.ALL &&
      otherFilterElement.checked &&
      otherFilterElement !== filterElement
    );

    if (filterElement === filterAllElement) {
      otherCheckedFilterElements.forEach((otherFilterElement: HTMLInputElement) => {
        otherFilterElement.checked = false;
      });

      if (!filterAllElement.checked) {
        filterAllElement.checked = true;
      }
    } else {
      if (filterAllElement) {
        filterAllElement.checked = !filterElement.checked && !otherCheckedFilterElements.length;
      }
    }
  }

  private doFilter(filterForm: HTMLFormElement): void {
    const filterData = FilterFormComponent.getFilterData(filterForm);
    const filterTargets = document.querySelectorAll(FilterFormComponent.filterTargetSelector);

    filterTargets.forEach((filterTarget: HTMLElement) => {
      const filterTargetDataElement = filterTarget.querySelector(FilterFormComponent.filterTargetDataSelector)

      let targetData: FilterData = {};

      if (filterTargetDataElement) {
        targetData = JSON.parse(filterTargetDataElement.textContent) as FilterData;
      }

      let hidden = false;

      Object.keys(filterData).forEach((key) => {
        const filterDataFragment: string[] = filterData[key];
        const targetDataFragment: string[] = targetData[key] || [];

        if (!filterDataFragment) { return; }

        if (!filterDataFragment.some(value => targetDataFragment.includes(value))) {
          hidden = true;
        }
      });

      filterTarget.hidden = hidden;
    });
  }

  private onFilterChange(event: Event): void {
    const filterForm = (event.target as HTMLInputElement)?.form;

    this.toggleFilterChange(event.target as HTMLInputElement);
    this.doFilter(filterForm);
  }

  private setupEvents(): void {
    document.querySelectorAll(FilterFormComponent.filterFormSelector).forEach((filterForm: HTMLFormElement) => {
      this.doFilter(filterForm);
      filterForm.addEventListener('change', this.onFilterChange.bind(this));
    });
  }

  private initFilterValues(): void {
    this.filterLabelTemplate = document.querySelector(FilterFormComponent.filterTemplateSelector);
    if(this.filterLabelTemplate) {
      this.setFilterLabelValues(this.getAllFilterValues());
    }
  }

  private getAllFilterValues(): FilterData {
    // currently only working for serviceAreas and branches due to complexity reduction
    const allFilterValues: FilterData = {"serviceAreas": [], "branches": []};
    const filterTargets = document.querySelectorAll(FilterFormComponent.filterTargetSelector);

    filterTargets.forEach((filterTarget: HTMLElement) => {
      const filterTargetDataElement = filterTarget.querySelector(FilterFormComponent.filterTargetDataSelector);
      let targetData: FilterData;

      if (filterTargetDataElement) {
        targetData = JSON.parse(filterTargetDataElement.textContent) as FilterData;

        allFilterValues["serviceAreas"] = allFilterValues["serviceAreas"].concat(
          targetData["serviceAreas"].filter((item) => !allFilterValues["serviceAreas"].includes(item))
        );

        allFilterValues["branches"] = allFilterValues["branches"].concat(
          targetData["branches"].filter((item) => !allFilterValues["branches"].includes(item))
        );
      }
    });

    return allFilterValues;
  }

  private setFilterLabelValues(filterValues: FilterData): void {
    const filterForm = document.querySelector(FilterFormComponent.filterFormSelector);
    const filterLabelSets = filterForm.querySelectorAll(`[${FilterFormComponent.filterNameSelector}]`);

    filterLabelSets.forEach((labelSet) => {

      const name = labelSet.getAttribute(FilterFormComponent.filterNameSelector);
      const currentValues = filterValues[name];

      if(currentValues) {
        currentValues.forEach((value) => {
          labelSet.appendChild(this.newFilterLabel(value, name));
        })
      }
    })
  }

  private newFilterLabel(value: string, category: string): HTMLElement {
    const filterLabelTemplate = this.filterLabelTemplate.content.querySelector("label").cloneNode(true) as HTMLElement;

    filterLabelTemplate.querySelector("input").setAttribute("name", category);
    filterLabelTemplate.querySelector("input").setAttribute("value", value);
    filterLabelTemplate.querySelector("span").textContent = value;

    return filterLabelTemplate;
  }

  public init() {
    window.addEventListener('load', this.setupEvents.bind(this));
    this.initFilterValues();
  }

  protected constructor() { }
}
